// extracted by mini-css-extract-plugin
module.exports = {"title":"WhyBuyFromUs_title__4iqRN","product":"WhyBuyFromUs_product__ji_B7","product__row":"WhyBuyFromUs_product__row__oLvQJ"};